import { CalendarIcon, ClockIcon } from "@xola/icons";
import { Alert, Currency, formatDate } from "@xola/ui-kit";
import clsx from "clsx";
import React from "react";
import { ExperiencePurchaseItem, Product, Purchase } from "types";
import { useSeller } from "../../../hooks/useAccount";
import { numberFormat } from "../../../utils/numbers";
import { ProductImage } from "../../Common/ProductImage";

interface ExperienceTileProps {
    item: ExperiencePurchaseItem;
    product: Product;
}

export const ExperienceTile = ({ item, product }: ExperienceTileProps) => {
    return (
        <div className="rounded-lg bg-gray-lighter">
            <div className={clsx("mb-2 flex space-x-1 rounded-lg p-4")}>
                <ProductImage size="small" product={product} />

                <div className="flex w-full flex-col justify-between">
                    <div className="font-bold leading-4">{product.name}</div>

                    <div className="flex justify-between text-gray-darker">
                        <span className="space-x-1">
                            <CalendarIcon />
                            <span>{formatDate(item.arrivalDateTime, "ddd LL")}</span>
                        </span>

                        {item.arrivalTime ? (
                            <span>
                                <ClockIcon /> {formatDate(item.arrivalDateTime, "LT")}
                            </span>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
};

export const SplitPayWarningAlert = ({ purchase, totalSum }: { purchase: Purchase; totalSum: number }) => {
    const seller = useSeller();
    return (
        <Alert color="warning" className="text-left">
            Your calculated amount of <Currency currency={seller.currency}>{totalSum}</Currency> exceeds the outstanding
            balance on this purchase. We will automatically cap your payment to{" "}
            <strong>
                <Currency currency={seller.currency}>{numberFormat(purchase.balance)}</Currency>
            </strong>
        </Alert>
    );
};
